export type BaseHeight = {
  appHeaderHeight: string;
  appFooterHeight: string;
  appFileDetailHeaderHeight: string;
  appContainerBreadcrumbTitleButton: string;
  appMarkerSignatureHeight: string;
  appSignaturePadHeight: string;
  appHeaderAndDetailHeight: number;
  appDocsPdfPageSpacingHeight: number;
};

export const baseHeight: BaseHeight = {
  appHeaderHeight: "56px",
  appFileDetailHeaderHeight: "56px",
  appFooterHeight: "56px",
  appContainerBreadcrumbTitleButton: "144px",
  appMarkerSignatureHeight: "32px",
  appSignaturePadHeight: "150px",
  appHeaderAndDetailHeight: 112,
  appDocsPdfPageSpacingHeight: 16,
} as const;
